export default __webpack_public_path__ + "static/media/livechat-active.58655c0b.svg";